<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M11.1 16.8h1.8v-3.9h3.9v-1.8h-3.9V7.2h-1.8v3.9H7.2v1.8h3.9zm.9 4.8a9.68 9.68 0 0 1-8.86-5.87 9 9 0 0 1-.74-3.74q0-2 .75-3.73a9.7 9.7 0 0 1 5.12-5.11 9 9 0 0 1 3.74-.75 9 9 0 0 1 3.73.75 9.7 9.7 0 0 1 5.11 5.12q.75 1.74.75 3.72t-.75 3.73a9.7 9.7 0 0 1-5.12 5.13q-1.74.75-3.72.75"
      />
    </svg>
  </span>
</template>
